import { objUtil, typeUtil, logUtil } from "@repo/lib-common";
import { currencyUtil } from "@repo/lib-web";




const decimalZero = 0.0;

export const enum CustomerType {
  new = "new",
  returned = "returned"
}

export const enum OfferDimension {
  categoryName = 0,
  categoryId = 1,
  categoryList = 2,
  brandName = 3,
  sellerId = 4,
}


export class PurchaseOrderLineItem {
  /** (optional) uniq id of the purchase order linte item */
  offerDimension: OfferDimension = OfferDimension.categoryName;

  /** (optional) uniq id of the purchase order linte item */
  id: typeUtil.StringOrUndefined = objUtil.uuidStr();

  /** (required) uniq id of the product */
  sku: typeUtil.StringOrUndefined;

  /** (optional) product code or barcode */
  productCode: typeUtil.StringOrUndefined;

  /** (required) product name */
  productName: typeUtil.StringOrUndefined;

  /** (optional) uniq id of seller */
  sellerId: typeUtil.StringOrUndefined;

  /** (optional) product type name */
  productTypeName: typeUtil.StringOrUndefined;

  /** (optional) category name of the product */
  categoryName: typeUtil.StringOrUndefined;

  /** (optional) category id of the product */
  categoryId: typeUtil.StringOrUndefined;

  /** (optional) category ids or names list of the product */
  categoryList? = new Array<string>();

  /** (optional) brand name of the product */
  brandName: typeUtil.StringOrUndefined;

  /** (optional) brand id of the product */
  brandId: typeUtil.StringOrUndefined;

  /** (optional) unit sale price after discount and after tax (after discounts and tax applied) */
  unitSalePrice: typeUtil.NumberOrUndefined = decimalZero;

  /** (optional) quantity */
  quantity: number = 0;

  /** (required) sub total amount of the product after all discounts and taxes (what customer payed for this line) = unitSalePrice * quantity */
  lineAmount: typeUtil.NumberOrUndefined = decimalZero;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public toApiObject(): any {

    const eventData01 = {
      offerDimension: this.offerDimension,
      id: this.id,
      sku: this.sku,
      productCode: this.productCode,
      productName: this.productName,
      productTypeName: this.productTypeName,
      sellerId: this.sellerId,
      categoryName: this.categoryName,
      categoryId: this.categoryId,
      brandName: this.brandName,
      brandId: this.brandId,
      unitSalePrice: this.unitSalePrice,
      quantity: this.quantity,
      lineAmount: this.lineAmount



    };
    return eventData01;
  }

}

export function validatePurchaseOrderLineItem(
  data: PurchaseOrderLineItem
): boolean {
  if (objUtil.isObjNullOrUndefined(data)) {
    logUtil.consoleError("order line is undefined");
    return false;
  }
  if (objUtil.isNullOrEmpty(data!.productName)) {
    logUtil.consoleError("productName is undefined");
    return false;
  }
  if (objUtil.isNumNullOrUndefined(data!.lineAmount)) {
    logUtil.consoleError("lineAmount is undefined");
    return false;
  }
  //   if(isNumNullOrUndefined(data!.unitSalePrice) || data!.unitSalePrice==decimalZero) {
  //       consoleError("unitSalePrice is undefined");
  //       return false;
  //   }

  return true;
}

export class PurchaseOrder {
  constructor(init?: Partial<PurchaseOrder>) {
    Object.assign(this, init);
  }
  /** (required) uniq id of the customer / buyer */
  customerId: typeUtil.StringOrUndefined;

  /** (optional) uniq id of purchase order */
  orderId: typeUtil.StringOrUndefined;

  /** (required) order number */
  orderNumber: typeUtil.StringOrUndefined;

  /** (optional) sales channel (default:web)  */
  salesChannel: typeUtil.StringOrUndefined = "web";

  /** (required) purchased line items  */
  items: Array<PurchaseOrderLineItem> = new Array<PurchaseOrderLineItem>();

  totalAmount: typeUtil.NumberOrUndefined = decimalZero;

  /** (default TRY) 3 digit currecy code https://en.wikipedia.org/wiki/ISO_4217  */
  currencyCode: string = currencyUtil.Currency.TRY.Code

  goalName: typeUtil.StringOrUndefined;
}

export function validatePurchaseOrder(
  data: PurchaseOrder | undefined
): boolean {
  if (objUtil.isObjNullOrUndefined(data)) {
    logUtil.consoleError("order is undefined");
    return false;
  }
  if (objUtil.isNullOrEmpty(data!.orderNumber)) {
    logUtil.consoleError("orderNumber is undefined");
    return false;
  }
  if (objUtil.isNullOrEmpty(data!.customerId)) {
    logUtil.consoleError("customerId is undefined");
    return false;
  }

  if (objUtil.isNumNullOrUndefined(data!.totalAmount) || data?.totalAmount === decimalZero) {
    logUtil.consoleError("totalAmount is undefined");
    return false;
  }

  if (objUtil.isObjNullOrUndefined(data!.items) || data!.items.length == 0) {
    logUtil.consoleError("items are undefined");
    return false;
  }

  //validate items
  for (let itemIndex = 0; itemIndex < data!.items!.length; itemIndex++) {
    const item = data!.items[itemIndex];
    if (!validatePurchaseOrderLineItem(item)) {
      return false;
    }
  }



  // if(isNullOrEmpty(data!.orderId)) {
  //     consoleError("orderId is undefined");
  //     return false;
  // }
  return true;

}


